import React from 'react';
import PropTypes from 'prop-types';
import editSquareGreyIcon from 'assets/images/icons/edit-square-grey.svg';
import ColorChangeDropdown from 'components/common-components/ColorChangeDropdown';
import { dashboardWidgetThemeColors } from '../utils';

const DashboardThemeColorPicker = ({ name, value, handleChange }) => {
  const default_color = '#ff0000';
  return (
    <div>
      <div className='widget-color-list'>
        {dashboardWidgetThemeColors.map((singleColor, key) => (
          <div
            key={key}
            className='color-div cursor-pointer'
            style={{ backgroundColor: singleColor }}
            onClick={() => {
              handleChange(name, singleColor);
            }}
          ></div>
        ))}
        <div
          className='color-div'
          style={{
            backgroundColor: value,
          }}
        ></div>
        <div className='d-flex'>
          <ColorChangeDropdown
            name={'item'}
            toggleComponent={
              <>
                <img src={editSquareGreyIcon} />
              </>
            }
            toggleClasses='cursor-pointer'
            styleProperties={{
              itemColor: value || default_color,
            }}
            handleChange={(fieldName, fieldValue) => {
              handleChange(name, fieldValue);
            }}
            hideFontSizeOption
            hideOpacityOption
          />
        </div>
      </div>
    </div>
  );
};

DashboardThemeColorPicker.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default DashboardThemeColorPicker;
